export default {
  'zh-CN': {
    home: {
      title: '芙崽 Fuzozo',
      subtitle: '开发调试面板',
      languageTitle: '语言参数',
      languageDesc: '给跳转链接统一附带 lang 参数',
      appSection: '应用入口',
      appDownload: 'APP 下载',
      appDownloadDesc: '打开统一下载页，选择 iOS App Store 或 Android 安装包',
      taskSection: '任务页面',
      newbieTask: '新手任务',
      dailyTask: '成长任务',
      growthReward: '成长奖励来信',
      growthRewardHint: '用于预览奖励档案来信页面；有 dlpId 和 rewardId 时会请求接口，否则使用下面的预览内容。',
      dlpId: 'dlpId',
      dlpPlaceholder: '输入 dlpId',
      token: 'Token',
      tokenPlaceholder: '粘贴 token（选填）',
      rewardId: 'rewardId',
      rewardIdPlaceholder: '输入 rewardId',
      apiEnvironment: 'API 环境',
      production: '正式环境',
      test: '测试环境',
      mockLabel: 'Mock 数据',
      debugLabel: 'API 调试',
      toggleOn: '开启',
      toggleOff: '关闭',
      previewContent: '预览内容',
      previewContentPlaceholder: '没有 dlpId/rewardId 时使用',
      enterPage: '进入页面',
      legalSection: '法律文件',
      privacyPolicy: '隐私政策',
      userAgreement: '用户服务协议',
      paidServiceAgreement: '付费服务协议',
      dataTrafficPurchaseAgreement: '流量购买协议',
      personalInfoCollection: '个人信息收集清单',
      thirdPartySharing: '第三方信息共享清单',
      dataDeletion: '数据删除说明',
      qaSection: '帮助与 QA',
      registerHelp: '注册帮助',
      deviceHelpQa: '帮助 QA',
      digitalLifeQa: '数字生命 QA',
      previewSection: '快速预览（Mock）',
      newbiePreview: '新手任务（Mock 数据）',
      dailyPreview: '成长任务（Mock 数据）',
      growthRewardPreview: '成长奖励来信（预览内容）'
    }
  },
  en: {
    home: {
      title: 'Fuzozo',
      subtitle: 'Developer Debug Panel',
      languageTitle: 'Language Parameter',
      languageDesc: 'Append a unified `lang` query to all routes',
      appSection: 'App Entry',
      appDownload: 'App Download',
      appDownloadDesc: 'Open the unified download page for the iOS App Store or Android APK',
      taskSection: 'Task Pages',
      newbieTask: 'Beginner Task',
      dailyTask: 'Growth Task',
      growthReward: 'Growth Reward Letter',
      growthRewardHint: 'Preview the reward letter page. An API request is made when dlpId and rewardId are provided; otherwise the preview content below is used.',
      dlpId: 'dlpId',
      dlpPlaceholder: 'Enter dlpId',
      token: 'Token',
      tokenPlaceholder: 'Paste token (optional)',
      rewardId: 'rewardId',
      rewardIdPlaceholder: 'Enter rewardId',
      apiEnvironment: 'API Environment',
      production: 'Production',
      test: 'Test',
      mockLabel: 'Mock Data',
      debugLabel: 'API Debug',
      toggleOn: 'On',
      toggleOff: 'Off',
      previewContent: 'Preview Content',
      previewContentPlaceholder: 'Used when dlpId/rewardId are empty',
      enterPage: 'Open Page',
      legalSection: 'Legal Pages',
      privacyPolicy: 'Privacy Policy',
      userAgreement: 'User Service Agreement',
      paidServiceAgreement: 'Paid Service Agreement',
      dataTrafficPurchaseAgreement: 'Data Traffic Purchase Agreement',
      personalInfoCollection: 'Personal Information Collection List',
      thirdPartySharing: 'Third-Party Information Sharing List',
      dataDeletion: 'Data Deletion Instructions',
      qaSection: 'Help & Q&A',
      registerHelp: 'Registration Help',
      deviceHelpQa: 'Help Q&A',
      digitalLifeQa: 'Digital Life Q&A',
      previewSection: 'Quick Preview (Mock)',
      newbiePreview: 'Beginner Task (Mock)',
      dailyPreview: 'Growth Task (Mock)',
      growthRewardPreview: 'Growth Reward Letter (Preview)'
    }
  },
  ja: {
    home: {
      title: 'フーゾゾ Fuzozo',
      subtitle: '開発デバッグパネル',
      languageTitle: '言語パラメータ',
      languageDesc: 'すべての遷移先に統一して `lang` を付与します',
      appSection: 'アプリ導線',
      appDownload: 'アプリダウンロード',
      appDownloadDesc: 'iOS App Store または Android APK を選べる統一ダウンロードページを開きます',
      taskSection: 'タスクページ',
      newbieTask: '初心者タスク',
      dailyTask: '成長タスク',
      growthReward: '成長報酬レター',
      growthRewardHint: '報酬レターページをプレビューします。dlpId と rewardId がある場合は API を呼び出し、それ以外の場合は下記のプレビュー内容を使用します。',
      dlpId: 'dlpId',
      dlpPlaceholder: 'dlpId を入力',
      token: 'Token',
      tokenPlaceholder: 'token を貼り付け（任意）',
      rewardId: 'rewardId',
      rewardIdPlaceholder: 'rewardId を入力',
      apiEnvironment: 'API 環境',
      production: '本番環境',
      test: 'テスト環境',
      mockLabel: 'Mock データ',
      debugLabel: 'API デバッグ',
      toggleOn: 'オン',
      toggleOff: 'オフ',
      previewContent: 'プレビュー内容',
      previewContentPlaceholder: 'dlpId/rewardId がない場合に使用',
      enterPage: 'ページを開く',
      legalSection: '法務ページ',
      privacyPolicy: 'プライバシーポリシー',
      userAgreement: '利用規約',
      paidServiceAgreement: '有料サービス規約',
      dataTrafficPurchaseAgreement: 'データ通信購入規約',
      personalInfoCollection: '個人情報収集一覧',
      thirdPartySharing: '第三者情報共有一覧',
      dataDeletion: 'データ削除案内',
      qaSection: 'ヘルプとQ&A',
      registerHelp: '登録ヘルプ',
      deviceHelpQa: 'ヘルプQ&A',
      digitalLifeQa: 'デジタルライフQ&A',
      previewSection: 'クイックプレビュー（Mock）',
      newbiePreview: '初心者タスク（Mock）',
      dailyPreview: '成長タスク（Mock）',
      growthRewardPreview: '成長報酬レター（プレビュー）'
    }
  },
  'zh-TW': {
    home: {
      title: '芙崽 Fuzozo',
      subtitle: '開發調試面板',
      languageTitle: '語言參數',
      languageDesc: '為所有跳轉統一附帶 lang 參數',
      appSection: '應用入口',
      appDownload: 'APP 下載',
      appDownloadDesc: '開啟統一下載頁，選擇 iOS App Store 或 Android 安裝包',
      taskSection: '任務頁面',
      newbieTask: '新手任務',
      dailyTask: '成長任務',
      growthReward: '成長獎勵來信',
      growthRewardHint: '用於預覽獎勵檔案來信頁面；有 dlpId 和 rewardId 時會請求介面，否則使用下方的預覽內容。',
      dlpId: 'dlpId',
      dlpPlaceholder: '輸入 dlpId',
      token: 'Token',
      tokenPlaceholder: '貼上 token（選填）',
      rewardId: 'rewardId',
      rewardIdPlaceholder: '輸入 rewardId',
      apiEnvironment: 'API 環境',
      production: '正式環境',
      test: '測試環境',
      mockLabel: 'Mock 資料',
      debugLabel: 'API 除錯',
      toggleOn: '開啟',
      toggleOff: '關閉',
      previewContent: '預覽內容',
      previewContentPlaceholder: '沒有 dlpId/rewardId 時使用',
      enterPage: '進入頁面',
      legalSection: '法律文件',
      privacyPolicy: '隱私政策',
      userAgreement: '使用者服務協議',
      paidServiceAgreement: '付費服務協議',
      dataTrafficPurchaseAgreement: '流量購買協議',
      personalInfoCollection: '個人資訊蒐集清單',
      thirdPartySharing: '第三方資訊共享清單',
      dataDeletion: '資料刪除說明',
      qaSection: '幫助與 QA',
      registerHelp: '註冊幫助',
      deviceHelpQa: '幫助 QA',
      digitalLifeQa: '數位生命 QA',
      previewSection: '快速預覽（Mock）',
      newbiePreview: '新手任務（Mock 資料）',
      dailyPreview: '成長任務（Mock 資料）',
      growthRewardPreview: '成長獎勵來信（預覽內容）'
    }
  }
}
